module.exports = __webpack_public_path__ + "static/media/tg5.5af27e4b.jpg";